import React, { ComponentType, useEffect, useMemo, useState } from 'react';
import { useStateContext } from '../../hooks/useStateContext';
import {Switch, Table, TableContainer, TableRow, Typography} from '@mui/material';
import { debounce } from 'lodash';
import api from '../../services/api';
import { useParams } from 'react-router-dom';
import { views } from '../../schema/views';
import {Header} from "./Header";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Grid from '@mui/material/Unstable_Grid2';

export const RequiredFields: ComponentType = () => {
  const { user } = useStateContext();

  const [required, setRequired] = useState<any>({});
  const [names, setNames] = useState<any>({});

  const debouncedOnChange = debounce(handleDebouncedOnChange, 500);

  const { id: viewIdFromUrl } = useParams();
  const viewId = viewIdFromUrl !== undefined ? parseInt(viewIdFromUrl) : NaN;

  useEffect(() => {
    document.title = `Zoe - Required Fields`;
  }, []);

  function handleDebouncedOnChange(
    schema: any,
    column: string,
    checked: boolean
  ) {
    api.patch(`/required-fields`, {
      column: column,
      table: schema?.table,
      checked: checked,
    });
  }

  useEffect(() => {
    api.get(`/required-fields/${user.id}`).then((res: any) => {
      const names: any = {};
      Object.keys(views).map((viewName: any) => {
        names[`${viewName}`] = {};
        const view: any = views[`${viewName}` as keyof {}];
        Object.keys(view?.columns).map((item: any) => {
          names[`${viewName}`][`${item}`] = view?.columns[item]?.name;
        });
      });
      setNames(names);

      const mainViews: any = {};

      res.map((item: any) => {
        if (
          item?.table === 'group' ||
          item?.table === 'activity_reservation' ||
          item?.table === 'accommodation_reservation'
        ) {
          const fields: any = {};
          const req = item.required ? item.required : [];
          req.map((field: any) => {
            fields[`${field}`] = true;
          });

          mainViews[`${item?.table}`] = fields;
        }
      });

      setRequired(mainViews);
    });
  }, []);

  const tables: any = useMemo(() => {
    return user.views;
  }, [user]);

  return (
    <>
      <Header
        title={'Required Fields'}
        subTitle={
          'Schema required fields.'
        }
      />

      <Box
        sx={{
          padding: '15px',
          flexGrow: 1,
          overflow: 'auto',
        }}
      >
        <Grid container spacing={'20px'}>

          {Object.keys(names).length ? (

              tables.map((schema: any) => {

                if (!schema?.table || schema.table === 'crazy-groups'|| schema.table === 'crazy-bookings'){
                  return <></>;
                }

                const tableFields = required[`${schema?.table}`]
                  ? required[`${schema?.table}`]
                  : {};
                return (
                  <>
                  <Grid sm={12} md={6} lg={3}>
                    <Box>
                      <Card variant="outlined">
                        <CardContent>
                          <Typography variant={'h6'} color="#666" gutterBottom>
                            {schema?.name}
                          </Typography>

                          <TableContainer>
                            <Table
                              sx={{
                                '& .MuiTableCell-root': {
                                  padding: '5px',
                                },
                              }}
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell align="left">Name</TableCell>
                                  <TableCell align="right">Required</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody
                                sx={{
                                  maxHeight: '300px',
                                }}
                              >

                                {schema.columns.map((column: any, index:number) => {
                                  console.log(column?.name);
                                  return (
                                    <>
                                      <TableRow key={index}>
                                        <TableCell align="left">
                                          {names[`${schema?.table}`][`${column?.name}`]}
                                        </TableCell>
                                        <TableCell align="right">
                                          <Switch
                                            aria-label={'asd'}
                                            checked={tableFields[`${column?.name}`]}
                                            onChange={(event, checked) => {
                                              debouncedOnChange(
                                                schema,
                                                column?.name,
                                                checked
                                              );

                                              const values = {
                                                ...required[`${schema?.table}`],
                                              };
                                              values[`${column?.name}`] = checked;

                                              setRequired({
                                                ...required,
                                                [`${schema?.table}`]: values,
                                              });
                                            }}
                                          />
                                        </TableCell>
                                      </TableRow>
                                    </>
                                  );
                                })}

                              </TableBody>
                            </Table>
                          </TableContainer>

                        </CardContent>
                      </Card>
                    </Box>
                  </Grid>
                  </>
                );
              })

          ) : (
            <></>
          )}

        </Grid>
      </Box>
    </>
  );
};
